(function ($) {
    /* Custom JS */

    $('.sub-nav ul.navbar-nav').tinyNav({
        active: 'selected', // String: Set the "active" class
        // header: SiteInfo['queriedObject']['name'], // String: Specify text for "header" and show header instead of the active item
        header: 'Menu',
        indent: '- ', // String: Specify text for indenting sub-items
        label: '', // String: Sets the <label> text for the <select> (if not set, no label will be added)
    });

    $('.tinynav').on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) {
            // require a URL
            window.location = url; // redirect
        }
        return false;
    });

    // $(function () {
    //     if ('undefined' !== typeof FWP) {
    //         FWP.auto_refresh = false;
    //     }
    // });
})(jQuery);
